import React, { Component } from "react";
import queryString from 'query-string'
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Slider from "../Helpers/Slider/Slider";
import Timeline from "../Common/Timeline/Timeline";
import _Content from "../../static/data/content.json";
import { groupBy } from "../Services/Array";
import Slide from "../Common/Slide/Slide";
import "./VoteScreen.scss";
import EndScreen from "./EndScreen";
import { clearTimeouts } from "../Services/Timing";
import { handleSelected } from "../Services/Storage";
import CreditScreen from "./CreditScreen";

const __Categories__ = groupBy(_Content, g => g.Category);
const __CategoriesLength__ = groupBy(_Content, g => g.Category).size;

export default class VoteScreen extends Component {
    constructor(props) {
        super();
        this.ini8 = this.ini8.bind(this);
        this.setOwlRef = this.setOwlRef.bind(this);
        this.renderCategories = this.renderCategories.bind(this);
        this.setNavBar = this.setNavBar.bind(this);
        this.selectOption = this.selectOption.bind(this);
        this.toggleEndScreen = this.toggleEndScreen.bind(this);
        this.toggleCreditScreen = this.toggleCreditScreen.bind(this);
        this.deleteCategory = this.deleteCategory.bind(this);
        this.state = {
            CurrentSlide: 0,
            Categories: [],
            OwlRef: {},
            Selected: {},
            showEndScreen: false,
            showCreditScreen: false,
            AppWebView: false
        }
    }
    componentDidMount() {
        this.ini8();
        this.renderCategories();
        window.addEventListener("toggleEndScreen", this.toggleEndScreen);
        window.addEventListener("toggleCreditScreen", this.toggleCreditScreen);
        const qs = queryString.parse(window.location.search);
        if (qs.appview == 1 && qs) {
            this.setState({
                AppWebView: true
            })
        }
    }
    ini8() { }
    toggleEndScreen() {
        if (this.state.showEndScreen == false &&
            (Object.keys(this.state.Selected).length == __CategoriesLength__ || (this.state.Selected[this.state.CurrentSlide] && this.state.CurrentSlide == __CategoriesLength__ - 1))) {
            clearTimeouts();
            this.setState({
                showEndScreen: true
            })
        }
    }
    toggleCreditScreen() {
        window.dispatchEvent(new CustomEvent("toggleCreditScreenBTN", {
            "detail": "toggleCreditScreenBTN"
        }));
        this.setState({
            showCreditScreen: !this.state.showCreditScreen
        })
    }
    setOwlRef(ref) {
        if (!ref) return;
        this.setState({
            OwlRef: ref
        })
    }
    renderCategories() {
        let Slides = [], index = 0;

        __Categories__.forEach(obj => {
            Slides.push(<Slide key={index} index={index}
                items={obj}
                CategoryName={obj[0].Category}
                CategoryLength={__CategoriesLength__}
                setNavBar={this.setNavBar}
                selectOption={this.selectOption}
            />)
            index++;
        })

        this.setState({
            Categories: Slides
        })
    }
    setNavBar(event, time = 600) {
        let _index = typeof event == "object" ? event.item.index : event;
        this.setState({
            CurrentSlide: _index,
            showEndScreen: false
        }, () => {
            window.dispatchEvent(new CustomEvent(`_scrollDown_${_index}`, {
                "detail": "_scrollDown"
            }));
            if (typeof event != "object") {
                this.state.OwlRef.to(event, time);
            }
        })
    }
    selectOption(index) {
        let _selected = {
            ...this.state.Selected,
            [this.state.CurrentSlide]: index
        }
        handleSelected.set("selected", JSON.stringify(_selected));

        this.setState({
            Selected: _selected,
            showEndScreen: false
        }, () => {
            window.dispatchEvent(new CustomEvent("toggleEndScreen", {
                "detail": "toggleEndScreen"
            }));
        })
    }
    deleteCategory(category) {
        let _selected = {
            ...this.state.Selected
        }

        this.setState({
            Selected: _selected,
            CurrentSlide: category,
            showEndScreen: false
        });
        this.setNavBar(category, 0);

        window.dispatchEvent(new CustomEvent(`_resetSelected_${category}`, {
            "detail": "_resetSelected_"
        }));

        delete _selected[category];
    }
    render() {
        return (
            <section className={`section section-vote${this.state.showEndScreen ? " results" : ""}${this.state.showCreditScreen ? " credits" : ""}`}>
                <Header />
                <div className="padding" style={{ padding: this.state.AppWebView ? 0 : "" }}>
                    <div className="container">
                        <div className="blueline"></div>
                        <Timeline
                            Categories={__Categories__}
                            CategoryLength={__CategoriesLength__}
                            OwlRef={this.state.OwlRef}
                            Selected={this.state.Selected}
                            CurrentSlide={this.state.CurrentSlide}
                            showEndScreen={this.state.showEndScreen}
                        />
                        <div className="slider">
                            {this.state.Categories.length > 0 ?
                                <Slider
                                    setNavBar={this.setNavBar}
                                    Selected={this.state.Selected}
                                    setOwlRef={this.setOwlRef}>
                                    {this.state.Categories}
                                </Slider> : ""}
                        </div>
                    </div>
                </div>
                <EndScreen
                    Categories={__Categories__}
                    CategoryLength={__CategoriesLength__}
                    setNavBar={this.setNavBar}
                    Selected={this.state.Selected}
                    deleteCategory={this.deleteCategory}
                    OwlRef={this.state.OwlRef} />
                <CreditScreen
                    toggleCreditScreen={this.toggleCreditScreen} />
                <Footer />
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Screen/VoteScreen.jsx